module.exports = __webpack_public_path__ + "img/evntlLogo.7a76c2a3.svg";